var map = {
	"./blog.yml": 95,
	"./cloud.yml": 96,
	"./color.yml": 97,
	"./country.yml": 98,
	"./dio.yml": 99,
	"./doc.yml": 100,
	"./emoji.yml": 101,
	"./git.yml": 102,
	"./icon.yml": 103,
	"./license.yml": 104,
	"./link.yml": 105,
	"./metrics.yml": 106,
	"./people.yml": 107,
	"./soft.yml": 108,
	"./src.yml": 109,
	"./status.yml": 110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;